__webpack_require__.p = "https://www.asos.com/assets/";